import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class User extends AManagerApi {
    protected _url: string = '/user';
}
